export const CIS_INTERNAL = 'CIS_INTERNAL';
export const USER = 'USER';
export const RISK_MESSENGER = 'riskMessenger';
export const IBANK = 'iBank';

export const IS_LOCALHOST = process.env.ENVIRONMENT === 'localhost';

export const IS_DEV = ['development', 'stage'].includes(
  process.env.ENVIRONMENT
);

export const IS_PROD = ['production', 'prodstage'].includes(
  process.env.ENVIRONMENT
);

export const IS_ETS_NEXT =
  process.env.NEXT_PUBLIC_ETSNEXT_OVERLOAD === 'true' ||
  ['etsNext', 'etsNextSit'].includes(process.env.ENVIRONMENT);

export const IS_ETS_NEXT_PROD = process.env.ENVIRONMENT === 'etsNext';

if (!IS_LOCALHOST && !IS_DEV && !IS_PROD && !IS_ETS_NEXT) {
  throw new Error(
    'Invalid .env.ENVIRONMENT. Must be of values: localhost, development, stage, production, prodstage, etsNext'
  );
}

export const defaultTimezone =
  IS_ETS_NEXT && !IS_LOCALHOST ? 'GMT' : 'America/New_York';

// I removed the env variable. For local development, please change the value here.
// If you are reading a code review and the line below is changed, please ensure it was intentional.
export const IBANK_URL = IS_PROD
  ? 'https://apps.ciswired.com'
  : 'https://apps.dev.ciswired.com';

// This is an example of how you might set a local URL for development.
// export const IBANK_URL = 'http://127.0.0.1:51381';

export const IQCX_ERROR_STATES = {
  qualityControl: {
    title: 'QC Errors',
    message: 'Quality checks preventing ticketing',
  },
  alerts: {
    title: 'Alerts',
    message: 'PNR accuracy issues discovered',
  },
  exceptions: {
    title: 'Exceptions',
    message: 'Reasons PNRs were sent to reject queue',
  },
};

export const DEFAULT_LOGO = '/images/CornerstoneLogoColor.png';
export const DEFAULT_THEME_COLOR = '#040059';
export const DEFAULT_WELCOME_MESSAGE = 'Welcome to Upstream!';

export const QC_MAIL_TICKETING_CONFIG = {
  redirectBaseUrl: '/travel-management/qc-mail-ticketing/tables',
  defaultValues: {
    libraryType: 'local',
    allow_api_edit: false,
  },
};

export const LIBRARIES_CONFIG = {
  isLibrary: true,
  redirectBaseUrl: '/cis-internal-tools/libraries',
  defaultValues: {
    libraryType: 'restricted',
  },
};
